/**
 * unit of aging time
 */
export type AgingTimeUnit = 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';

export const AgingTimeUnit = {
  Day: 'DAY' as AgingTimeUnit,
  Week: 'WEEK' as AgingTimeUnit,
  Month: 'MONTH' as AgingTimeUnit,
  Year: 'YEAR' as AgingTimeUnit,
};
